import { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { initScrollAnimations } from "../utils/scrollAnimation";
import "../components/DeveloperPage.css";
import "../styles/global.css";

function Berke() {
  useEffect(() => {
    window.scrollTo(0, 0);
    initScrollAnimations();
  }, []);

  return (
    <main className="developer-page">
      <div className="developer-page-inner">
        <Link to="/" className="back-link scroll-fade-in">
          ← Back to Home
        </Link>
        <div className="developer-header scroll-fade-in">
          <img
            src="/WebsitePhotos/Berke_Palamutcu.jpg"
            alt="Berke Palamutcu"
            className="developer-image"
          />
          <div className="developer-info">
            <h1>Berke Palamutcu</h1>
            <p className="developer-role">Systems & IT</p>
          </div>
        </div>
        <div className="developer-content scroll-fade-in">
          <p>
            Secures your infrastructure, keeps deployments smooth and your stack
            quietly online.
          </p>
          <div className="developer-details">
            <h2>About</h2>
            <p>
              Berke has experience over 5 years working across the{" "}
              <strong>US, Europe, and Turkey</strong>. He brings deep expertise
              in{" "}
              <strong>fullstack development</strong>, combining technical
              innovation with strategic leadership to deliver cutting-edge
              solutions.
            </p>
            <p>
              With a strong background in building scalable systems and
              infrastructure, Berke has led teams in developing robust
              applications that serve global markets. His experience spans from
              training AI models to architecting complex fullstack applications,
              ensuring both performance and reliability at scale.
            </p>
            <p>
              Berke combines his technical expertise with business acumen,
              working across different time zones and cultures to bring
              innovative products to market. His international experience has
              given him unique insights into building solutions that work
              seamlessly across borders and markets.
            </p>
            <h2>Contact</h2>
            <p>
              <a
                href="mailto:bspalamutcu@gmail.com"
                className="developer-email"
              >
                bspalamutcu@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default Berke;
